import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const MESSAGES: Record<string, string> = {
  not_configured: "Google or Apple sign-in is not configured for this deployment.",
  failed: "Sign-in with that provider did not complete. Try again.",
  email_in_use:
    "That email already has an account with a password. Sign in with email and password, or use forgot password.",
};

export function useOAuthQueryMessage(): string | null {
  const [searchParams, setSearchParams] = useSearchParams();
  const [msg, setMsg] = useState<string | null>(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    const code = searchParams.get("oauth");
    if (!code) return;
    processed.current = true;
    setMsg(MESSAGES[code] ?? "Sign-in could not be completed.");
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete("oauth");
        return next;
      },
      { replace: true },
    );
  }, [searchParams, setSearchParams]);

  return msg;
}
